import React, { useState } from 'react';
import { Search, SlidersHorizontal, X } from 'lucide-react';
import Header from './components/Header9';
import Footer from './components/Footer9';
import ProductCard from './components/ProductCard';
import Button from './components/Button';

const Shop = () => {
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [sortBy, setSortBy] = useState('featured');
    const [showFilters, setShowFilters] = useState(false);
    const [wishlist, setWishlist] = useState({});

    const categories = ['All', 'Sarees', 'Kurtas', 'Lehengas', 'Sherwanis', 'Dupattas'];
    const sortOptions = [
        { value: 'featured', label: 'Featured' },
        { value: 'price-low', label: 'Price: Low to High' },
        { value: 'price-high', label: 'Price: High to Low' },
        { value: 'newest', label: 'Newest' },
    ];

    const products = [
        { id: 1, name: 'Chanderi Silk Saree', category: 'Sarees', price: 8999, tag: 'NEW', image: 'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 2, name: 'Banarasi Kurta Set', category: 'Kurtas', price: 6499, image: 'https://images.pexels.com/photos/3014853/pexels-photo-3014853.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 3, name: 'Embroidered Anarkali', category: 'Kurtas', price: 12999, tag: 'NEW', image: 'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 4, name: 'Handloom Cotton Dupatta', category: 'Dupattas', price: 2499, image: 'https://images.pexels.com/photos/6712360/pexels-photo-6712360.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 5, name: 'Silk Blend Lehenga', category: 'Lehengas', price: 18500, tag: 'NEW', image: 'https://images.pexels.com/photos/7275385/pexels-photo-7275385.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 6, name: 'Zardozi Sherwani', category: 'Sherwanis', price: 24999, image: 'https://images.pexels.com/photos/8953474/pexels-photo-8953474.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 7, name: 'Block Print Palazzo Set', category: 'Kurtas', price: 4999, image: 'https://images.pexels.com/photos/2955375/pexels-photo-2955375.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 8, name: 'Ikat Weave Kurta', category: 'Kurtas', price: 5499, tag: 'NEW', image: 'https://images.pexels.com/photos/3819793/pexels-photo-3819793.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 9, name: 'Kanjeevaram Silk Saree', category: 'Sarees', price: 15999, image: 'https://images.pexels.com/photos/2955819/pexels-photo-2955819.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 10, name: 'Chikankari Kurta', category: 'Kurtas', price: 3999, originalPrice: 5499, image: 'https://images.pexels.com/photos/2916387/pexels-photo-2916387.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 11, name: 'Banarasi Lehenga Set', category: 'Lehengas', price: 28999, image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 12, name: 'Tussar Silk Dupatta', category: 'Dupattas', price: 3499, originalPrice: 4999, image: 'https://images.pexels.com/photos/2220316/pexels-photo-2220316.jpeg?auto=compress&cs=tinysrgb&w=400' },
    ];

    const filteredProducts = selectedCategory === 'all'
        ? products
        : products.filter(p => p.category.toLowerCase() === selectedCategory.toLowerCase());

    const toggleWishlist = (id) => {
        setWishlist(prev => ({ ...prev, [id]: !prev[id] }));
    };

    return (
        <div className="w-full min-h-screen bg-white" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            <Header />
            <link href="https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

            {/* Page Header */}
            <div className="pt-20 md:pt-24 pb-8 bg-[#F8FAFC] border-b border-[#E2E8F0]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center gap-2 mb-2">
                        <div className="w-8 h-0.5 bg-[#2563EB]" />
                        <p className="text-xs tracking-[0.3em] uppercase text-[#2563EB] font-medium">Collection</p>
                    </div>
                    <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0F172A]">Shop</h1>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
                {/* Filters Bar */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8 pb-6 border-b border-[#E2E8F0]">
                    {/* Category Tabs */}
                    <div className="flex flex-wrap gap-2">
                        {categories.map((cat) => (
                            <button
                                key={cat}
                                onClick={() => setSelectedCategory(cat.toLowerCase())}
                                className={`px-4 py-2 text-xs font-medium tracking-wider uppercase rounded-none border transition-all duration-300 ${
                                    selectedCategory === cat.toLowerCase()
                                        ? 'bg-[#2563EB] border-[#2563EB] text-white'
                                        : 'bg-white border-[#E2E8F0] text-[#64748B] hover:border-[#2563EB] hover:text-[#2563EB]'
                                }`}
                            >
                                {cat}
                            </button>
                        ))}
                    </div>

                    {/* Sort & Filter */}
                    <div className="flex items-center gap-3">
                        <select
                            value={sortBy}
                            onChange={(e) => setSortBy(e.target.value)}
                            className="px-4 py-2 text-xs font-medium text-[#0F172A] border border-[#E2E8F0] rounded-none bg-white focus:outline-none focus:border-[#2563EB]"
                        >
                            {sortOptions.map((opt) => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                        <button
                            onClick={() => setShowFilters(!showFilters)}
                            className="md:hidden p-2 border border-[#E2E8F0] rounded-none hover:border-[#2563EB] transition-colors duration-300"
                        >
                            <SlidersHorizontal size={18} className="text-[#64748B]" />
                        </button>
                    </div>
                </div>

                {/* Results count */}
                <p className="text-sm text-[#64748B] mb-6 font-light">
                    Showing {filteredProducts.length} products
                </p>

                {/* Product Grid */}
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
                    {filteredProducts.map((product) => (
                        <ProductCard
                            key={product.id}
                            product={product}
                            onWishlistToggle={toggleWishlist}
                            isWishlisted={wishlist[product.id]}
                        />
                    ))}
                </div>

                {/* Load More */}
                <div className="text-center mt-12">
                    <Button variant="secondary" size="lg">
                        Load More
                    </Button>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Shop;
